<template>
  <div class="relative w-full min-h-screen bg-authBg">
    <div
      class="fixed inset-0 bg-gradient-to-r from-authGradient via-authGradientVia to-transparent z-0"
    ></div>

    <img
      src="../assets/images/login-logo.png"
      alt="Background"
      :class="[
        'fixed object-contain opacity-40 pointer-events-none z-0',
        windowWidth >= 768
          ? 'right-0 top-0 h-full'
          : 'bottom-[-20%] left-[20%] w-[100%]',
      ]"
    />
    <main
      class="relative z-10 min-h-screen flex flex-col justify-between p-5 pb-[34px] md:px-[80px] md:py-[58.6px] pt-[60px]"
    >
      <div class="self-center md:self-start w-full">
        <div class="flex items-center justify-between gap-4 w-full">
          <div v-html="lvedLabel()"></div>
          <LanguageDropdown :auth="true" />
        </div>
      </div>
      <div class="w-full flex flex-col items-center justify-center">
        <div v-show="!showAuthBg" class="flex justify-center mb-8 md:mb-10">
          <h1
            v-if="userStore.hasInvitation"
            class="h2 !font-400 font-just text-[32px] text-white m-0 text-center"
            v-html="
              $t('layoutLabels.youHaveBeenInvitedBy', {
                name: userStore.inviterName || '',
              })
            "
          ></h1>
          <h1
            v-else
            class="h2 !font-400 font-just text-xl md:text-4xl text-white m-0"
          >
            {{ $t("layoutLabels.keepYour") }}
            <span class="!font-[600]">{{ $t("layoutLabels.legacy") }}</span>
            {{ $t("layoutLabels.withinReach") }}
          </h1>
        </div>
        <div
          class="w-full max-w-xl"
          :class="{ 'bg-white rounded-3xl shadow-md': !showAuthBg }"
        >
          <slot name="main-content">
            <router-view></router-view>
          </slot>
        </div>
      </div>

      <div class="self-center md:self-start mt-5">
      </div>
    </main>
  </div>
</template>

<script setup>
import { lvedLabel } from "@/utils/commonSvg";
import { ref, onMounted, onUnmounted, provide, watch } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import LanguageDropdown from "@/components/common/LanguageDropdown.vue";
// Track window width for responsive layout
const windowWidth = ref(window.innerWidth);

// Control background styling toggle
const showAuthBg = ref(false);
provide("showAuthBg", showAuthBg);

// Access route and user store
const route = useRoute();
const userStore = useUserStore();

// Watch route changes for invitation code
watch(
  () => route.path,
  (path) => {
    if (path && route.query.invitationCode) {
      userStore.setInvitation(route.query);
    }
  },
  { immediate: true },
);

// Update windowWidth on resize
function handleResize() {
  windowWidth.value = window.innerWidth;
}

// Attach/remove resize listener
onMounted(() => {
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>
